import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {theme} from '../../../../styles';

export default function WelcomePage({
    setStepCount,
}: {
    setStepCount: SetState<number>;
}) {
    return (
        <div>
            <img
                style={{maxWidth: 250, textAlign: 'center'}}
                src='/static/img/icons/Illustration-V2_Bow.png'
            />
            <Typography variant='h5'>
                Get set up with the maps you need.
            </Typography>
            <Button
                fullWidth
                variant='contained'
                size='large'
                color='primary'
                style={{fontSize: 14, margin: theme.spacing(1)}}
                onClick={() =>
                    setStepCount((prevState: number) => prevState + 1)
                }
            >
                Get Started
            </Button>
        </div>
    );
}
